import { request } from '@/utils/request'

// TODO Оставлю как заглушку, убрать 01.02.26
export interface Widget {
  id: string
  name: string
  html: string
  size: string
  position: { column: number, row: number}
  isChartType: any
  chartOptions: any
  style: string
  raw: any
}

export type CustomWidget = {
  Info: {
    MachineName: string
    Description: string
    Name: string
    Size: string
    Type: string
    Weight: number
  }
  Data: {
    Html: string
    Raw: {
      Title: string
      Style: string
      Url: string
      IsSPA: boolean
      RowType: string
    }[]
    Show: boolean
    Style: string
  }
}

// TODO Оставлю как заглушку, убрать 01.02.26
// Определяем тип диаграммы типа pie и doughnut исходя из ее радиуса.
const getCurrentDiagramName = (type: string) => {
  let preparedType
  switch (type) {
    case 'doughnut':
      preparedType = ['25%', '55%']
      break
    case 'pie':
      preparedType = '55%'
      break
    default:
      preparedType = type
      break
  }
  return preparedType
}

const setColorset = (styleName: string, reverse?: boolean) => {
  let colorSet: string[] = []
  switch (styleName) {
    case 'RetroMetro':
      colorSet = ['#ea5545', '#f46a9b', '#ef9b20', '#edbf33', '#ede15b', '#bdcf32', '#87bc45', '#27aeef', '#b33dc6']
      break
    case 'DutchField':
      colorSet = ['#e60049', '#0bb4ff', '#50e991', '#e6d800', '#9b19f5', '#ffa300', '#dc0ab4', '#b3d4ff', '#00bfa0']
      break
    case 'RiverNights':
      colorSet = ['#b30000', '#7c1158', '#4421af', '#1a53ff', '#0d88e6', '#00b7c7', '#5ad45a', '#8be04e', '#ebdc78']
      break
    case 'SpringPastels':
      colorSet = ['#fd7f6f', '#7eb0d5', '#b2e061', '#bd7ebe', '#ffb55a', '#ffee65', '#beb9db', '#fdcce5', '#8bd3c7']
      break
    case 'BlueToYellow':
      colorSet = ['#115f9a', '#1984c5', '#22a7f0', '#48b5c4', '#76c68f', '#a6d75b', '#c9e52f', '#d0ee11', '#d0f400']
      break
    case 'GreyToRed':
      colorSet = ['#d7e1ee', '#cbd6e4', '#bfcbdb', '#b3bfd1', '#a4a2a8', '#df8879', '#c86558', '#b04238', '#991f17']
      break
    case 'BlackToPink':
      colorSet = ['#2e2b28', '#3b3734', '#474440', '#54504c', '#6b506b', '#ab3da9', '#de25da', '#eb44e8', '#ff80ff']
      break
    case 'Blues':
      colorSet = ['#0000b3', '#0010d9', '#0020ff', '#0040ff', '#0060ff', '#0080ff', '#009fff', '#00bfff', '#00ffff']
      break
    case 'BlueToRed':
      colorSet = ['#1984c5', '#22a7f0', '#63bff0', '#a7d5ed', '#e2e2e2', '#e1a692', '#de6e56', '#e14b31', '#c23728']
      break
    case 'OrangeToPurple':
      colorSet = ['#ffb400', '#d2980d', '#a57c1b', '#786028', '#363445', '#48446e', '#5e569b', '#776bcd', '#9080ff']
      break
    case 'PinkFoam':
      colorSet = ['#54bebe', '#76c8c8', '#98d1d1', '#badbdb', '#dedad2', '#e4bcad', '#df979e', '#d7658b', '#c80064']
      break
    case 'SalmonToAqua':
      colorSet = ['#e27c7c', '#a86464', '#6d4b4b', '#503f3f', '#333333', '#3c4e4b', '#466964', '#599e94', '#6cd4c5']
      break
    default:
      colorSet = setColorset('RetroMetro')
      break
  }
  if (reverse) {
    colorSet.reverse()
  }

  return colorSet
}

export const fetchCustomWidgets = async (formData: globalThis.FormData): Promise<any> => {
  try {
    const response = await request('/api/form/set', {
      method: 'POST',
      body: formData
    })
    return response.data.widgets || []
  } catch (error) {
    console.log(error)
  }
}

// TODO Оставлю как заглушку, убрать 01.02.26
export const fetchWidgets = async (): Promise<Widget[]> => {
  const config = JSON.parse(localStorage.getItem('widgets') ?? '{}')

  const response = await request('/main/widget', {
    method: 'GET'
  })

  const widgets = response.data.list.map((item: any) => {
    const widget = {
      id: item.Info.Uuid,
      name: item.Info.Name,
      html: item.Data.Html,
      isChartType: item.Data?.Raw?.ChartType || false,
      size: config[item.Info.Uuid] ? config[item.Info.Uuid].size : item.Info.Size,
      position: config[item.Info.Uuid] ? config[item.Info.Uuid].position : { column: 1, row: 1 },
      chartOptions: {
        color: setColorset(item.Data.Raw?.Colorset, item.Data.Raw?.ColorsetReverse),
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)',
        },
        legend: {
          orient: 'vertical',
          left: 'left',
          data: item.Data.Raw?.Items?.filter((item: any) => item.Value !== 0).map((item: any) => item.Label),
        },
        series: [
          {
            name: `${item.Info.Name}:`,
            type: 'pie',
            radius: getCurrentDiagramName(item.Data.Raw?.ChartType),
            center: ['50%', '50%'],
            data: item.Data.Raw?.Items?.filter((item: any) => item.Value !== 0).map((item: any) => {
              return {
                value: item.Value === 0 ? null : item.Value,
                name: item.Label
              }
            }),
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 10,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      },
      style: item.Data.Style === 'error' ? item.Data.Style = 'red' : item.Data.Style,
      raw: item.Data.Raw
    }

    return widget
  })

  const configured = !!widgets.find((widget: Widget) => {
    return widget.position.column !== 1 || widget.position.row !== 1
  })

  let top = 0
  let maxHeight = 0
  let left = 0
  if (!configured) {
    widgets.forEach((widget: Widget) => {
      const parts = widget.size.split('x')
      const width = parseInt(parts[0] ?? '0')
      const height = parseInt(parts[1] ?? '0')
      if (height > maxHeight) {
        maxHeight = height
      }

      if (left + width > 6) {
        left = 0
        top += maxHeight
        maxHeight = 0
      }
      widget.position.column += left
      widget.position.row += top
      left += width
    })
  }

  return widgets
}
